import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import { SYNC_OBJECT_RELATIONSHIPS } from '../mutations/SYNC_OBJECT_RELATIONSHIPS';

const useSync = () => {
    const [ sync ] = useMutation( SYNC_OBJECT_RELATIONSHIPS );

    const syncData = async ( saveData ) => {
        try {
            const response = await sync( { variables: { input: saveData } } );
            const success = response?.data?.result?.success !== false ;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error saving in useSync', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            syncData
        };
    }, [] );
};

export default useSync;
